<template>
  <footer>
    <div><img src="../assets/footer_logo.svg" alt="로고"></div>
    <small>Copyrightⓒ 2024 Joyportfolio. All Right Reserved.</small>
  </footer>
   
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
  footer{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 12vh;
  color: #9D9D9D;
  small{
    display: block;
    margin-left: 2%;
  }

}
</style>